<div class="col full-height layout-column">

  <cdk-virtual-scroll-viewport *ngIf="!!jobs && !!jobs?.length"
                               class="flex"
                               autosize
                               [minBufferPx]="600"
                               [maxBufferPx]="1200"
                               (scroll)="onScroll($event)">

    <app-planning-draft-jobs-panel-list-item *cdkVirtualFor="let job of jobs; trackBy: trackById"
                                             [draft]="draft"
                                             [job]="job"
                                             [route]="routesByJobMap[job.id]"
                                             [highlightedActivity]="highlightedActivity"
                                             [isSelected]="selectedKeys[job.id]"
                                             [settings]="settings"
                                             [isHideSelect]="isHideSelect"
                                             (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
                                             (onViewJob)="onViewJob.emit({jobs: $event.jobs, jobIds: $event.jobIds, event: $event.event})"
                                             (onToggle)="onToggleSelectedJob(job.id, $event.isSelected)">

    </app-planning-draft-jobs-panel-list-item>

  </cdk-virtual-scroll-viewport>


  <div *ngIf="!!jobs && !jobs?.length"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png"
                     text="No Services Found">

    </app-empty-state>
  </div>

  <!--Loading Mode-->
  <div *ngIf="!jobs"
       class="flex layout-row layout-align-center-center">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

</div>


<!--<div class="col full-height layout-column">-->

<!--  <div class="flex layout-column dndList overflow-auto">-->

<!--    <app-planning-draft-jobs-panel-list-item *ngFor="let job of jobs"-->
<!--                                             [job]="job"-->
<!--                                             [isSelected]="selectedKeys[job.id]"-->
<!--                                             [settings]="settings"-->
<!--                                             (onViewJob)="onViewJob.emit($event)"-->
<!--                                             (onToggle)="onToggleSelectedJob(job.id, $event)">-->

<!--    </app-planning-draft-jobs-panel-list-item>-->

<!--  </div>-->
<!--</div>-->
